import React from "react";
import "./dashboard.style.scss";
import DashboardBody from "./DashboardBody/DashboardBody";
import DashboardFooter from "./DashboardFooter/DashboardFooter";
import DashboardHeader from "./DashboardHeader/DashboardHeader";

export default function Dashboard() {
  return (
    <div className="dashboard-main">
      <DashboardHeader />
      <DashboardBody />
      <DashboardFooter />
    </div>
  );
}
